import { render } from "./DefaultLayout.vue?vue&type=template&id=c7bfc44a"
import script from "./DefaultLayout.vue?vue&type=script&lang=js"
export * from "./DefaultLayout.vue?vue&type=script&lang=js"
script.render = render

export default script